/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OTPAttestationData
 */
export interface OTPAttestationData {
    /**
     * 
     * @type {string}
     * @memberof OTPAttestationData
     */
    otp?: string;
}

/**
 * Check if a given object implements the OTPAttestationData interface.
 */
export function instanceOfOTPAttestationData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OTPAttestationDataFromJSON(json: any): OTPAttestationData {
    return OTPAttestationDataFromJSONTyped(json, false);
}

export function OTPAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPAttestationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'otp': !exists(json, 'otp') ? undefined : json['otp'],
    };
}

export function OTPAttestationDataToJSON(value?: OTPAttestationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'otp': value.otp,
    };
}

